// @ts-ignore
import SignaturePad from 'react-signature-canvas';
import { Flex, Button as MantineButton, useMantineTheme } from '@mantine/core';
import { useStyles } from './drawSignModal.styles';
import { CustomModal } from '../../../components/customModal';

export const DrawSignModal = ({
  opened, onClose, canvasRef, onSave, onClear,
}: any) => {
  const { classes, cx } = useStyles();
  const theme = useMantineTheme();
  const { colors } = theme.other;

  return (
    <CustomModal
      opened={opened}
      onClose={onClose}
      className={classes.cmodal}
    >
      <div className={cx('csMainContainer', classes.contentContainer)}>
        <div className="csHeader">
          <p className="heading_xs_semibold">
            Draw your signature below
          </p>
        </div>
        <div className={classes.contentContainer}>
          <div className={classes.signWrapper}>
            <SignaturePad
              ref={canvasRef}
              throttle={2}
              minWidth={1.5}
              maxWidth={1.5}
              minDistance={1}
              penColor={colors.primary.default}
              canvasProps={{
                className: classes.signContainer,
              }}
            />
          </div>
        </div>
        <div className={cx('csFooter', classes.footer)}>
          <div className={classes.btnWrapper}>
            <Flex className={classes.btnWrapperLeft}>
              <MantineButton
                disabled={false}
                variant="outline"
                onClick={onClose}
                radius={8}
                fullWidth
              >
                Close
              </MantineButton>
              <MantineButton
                disabled={false}
                onClick={onClear}
                radius={8}
                variant="outline"
                fullWidth
              >
                Clear
              </MantineButton>
            </Flex>
            <MantineButton
              disabled={false}
              sx={{ width: '40%' }}
              onClick={onSave}
              radius={8}
              fullWidth
            >
              Upload
            </MantineButton>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default DrawSignModal;
